<span>
  {{ alertListDisplay(dataItem) }}
</span>
